<!-- STANDARD Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa" 
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
       style="margin-right: 10px; cursor: pointer;" 
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- STANDARD Modal Body -->
<div class="modal-body" [hidden]="minimise">
  <ul class="nav nav-pills" role="tablist">
    @for (tab of tabs; track $index) {
<li [class.active]="tab.id === activeTab">
      <a (click)="activeTab = tab.id" style="cursor: pointer;" class="btn-sm">
        {{ tab.name }}
      </a>
    </li>
}
  </ul>

  <div class="tab-content">
    <!-- Form Entry Tab -->
    @if (activeTab === 1) {
<div class="tab-pane active">
      <div class="form-horizontal">
        @if (showFormLoader) {
<div class="formLoader">
          <i class="fa fa-spinner fa-spin gt-refresh"></i>
        </div>
}

        @if (!showFormLoader) {
<div>
          <!-- Entity Information Section -->
          <div class="row" style="padding-bottom: 0 !important;">
            <div class="container-fluid">
              @if (!isExamScenario) {
<div class="row">
                <div class="col-md-6">
                  <div class="col-md-1">
                    <span class="LayerLine1">Entity:</span>
                  </div>
                  <div class="col-md-10">
                    <span class="LayerData1  ng-binding">{{rowData.LEID + " " + ":" + " " + rowData.LE_NAME + " " + ":" + " " + rowData.TAX_YEAR_BEGIN + " " + "-" + " " + rowData.TAX_YEAR_END}}</span>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="col-md-2">
                    <span class="LayerLine1">Business:</span>
                  </div>
                  <div class="col-md-9">
                    <span class="LayerData1  ng-binding">{{rowData.ME_CODE + " " + "-" + " " + rowData.ME_NAME}}</span>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="col-md-6">
                    <span class="LayerLine1">Tax Code:</span>
                  </div>
                  <div class="col-md-6">
                    <span class="LayerData1  ng-binding">{{rowData.CDR_NO}}</span>
                  </div>
                </div>
              </div>
}
              
              @if (isExamScenario) {
<div class="row">
                <div class="col-md-4">
                  <div class="col-md-2">
                    <span class="LayerLine1">Entity:</span>
                  </div>
                  <div class="col-md-10">
                    <span class="LayerData1">{{rowData.LEID + " " + ":" + " " + rowData.LE_NAME + " " + ":" + " " + rowData.TAX_YEAR_BEGIN + " " + "-" + " " + rowData.TAX_YEAR_END}}</span>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="col-md-3">
                    <span class="LayerLine1">Business:</span>
                  </div>
                  <div class="col-md-9">
                    <span class="LayerData1">{{rowData.ME_CODE + " " + "-" + " " + rowData.ME_NAME}}</span>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="col-md-6">
                    <span class="LayerLine1">Tax Code:</span>
                  </div>
                  <div class="col-md-6">
                    <span class="LayerData1">{{rowData.CDR_NO}}</span>
                  </div>
                </div>
                <!-- Global Issue ID for Exam Scenario (matches AngularJS global-issue-id directive) -->
                <div class="col-md-3">
                  <span class="LayerLine1">
                    <p><strong>Current Issue ID</strong> :{{issue_short_desc}}</p>
                  </span>
                </div>
              </div>
}
            </div>

            <!-- Form Header -->
            <table style="width: 100%; border: 0px;">
              <tbody>
                <tr>
                  <th class="BlackSmHdrBC">
                    <h4>{{f4797Header.ATTRIB_DESCRIPTION}} <span style="color: red;"> (Inc/Dec)</span></h4>
                  </th>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                </tr>
              </tbody>
            </table>

            <table style="width: 100%; border: 0px;">
              <tbody>
                <tr>
                  <td style="width: 3px;">
                    <i class="fa fa-info-circle" style="font-size:24px;color:skyblue"></i>
                  </td>
                  <td class="BlackTxtBL">
                    {{f4797Header.ATTRIB_DESCRIPTION}} (Increase/Decrease Format)
                  </td>
                </tr>
              </tbody>
            </table>

            <!-- Main Data Table -->
            <table class="table table-bordered form-inline InnerTblBG custom-table">
              @for (row of f4797FormData; track trackByIndex(mainIndex); let mainIndex = $index) {
<tr class="row">
                <!-- TH (Table Header) Row Type -->
                @if (row.ROW_TYPE==='TH') {

                  @for (item of row.Line_data; track $index) {
<td style="font-weight: bold;"
                      [attr.colspan]="item.COLSPAN"
                      [attr.align]="item.COL_CLASS"
                      [ngClass]="{'color-red': item.DATA_TYPE === 'number' && item.ATTRIB_VALUE < 0}"
                     >
                    @if (item.DATA_TYPE === 'string') {

                      {{item.ATTRIB_VALUE}}
                    
} @else {

                      @if ((item.ATTRIB_DESCRIPTION || item.DESCRIPTION) === 'Unallocated Amount' && unAllocatedAmt !== 0) {
<p style="color:red;">
                        {{item.ATTRIB_VALUE | numberWithCommas}}
                      </p>
}
                      @if ((item.ATTRIB_DESCRIPTION || item.DESCRIPTION) === 'Unallocated Amount' && unAllocatedAmt === 0) {
<p style="color:green;">
                        {{item.ATTRIB_VALUE | numberWithCommas}}
                      </p>
}
                      @if ((item.ATTRIB_DESCRIPTION || item.DESCRIPTION) !== 'Unallocated Amount') {
<p>
                        {{item.ATTRIB_VALUE | numberWithCommas}}
                      </p>
}
                    
}
                    
                  </td>
}
                
}

                <!-- PH (Part Header) Row Type -->
                @if (row.ROW_TYPE==='PH') {
<td style="font-weight: bold;" colspan="12" class="row">
                  {{row.Line_data[0].ATTRIB_VALUE}}
                </td>
}

                <!-- DT (Data) Row Type -->
                @if (row.ROW_TYPE==='DT') {

                  @for (item of row.Line_data; track $index; let itemIndex = $index) {
<td [attr.colspan]="item.COLSPAN"
                      class="row">
                  @if (item.EDIT_TYPE==='currency' && item.DATA_TYPE==='number') {
<p>
                    <input [(ngModel)]="item.ATTRIB_VALUE" 
                           class="form-control input-md numText" 
                           type="text"
                           onlyDigitsDecimal
                           (blur)="updateAmount(itemIndex, item.LINE_NO)" 
                           (ngModelChange)="valueChanged(mainIndex, 0, item.LINE_NO, itemIndex)" 
                           [disabled]="item.IS_EDITABLE==='N'">
                    @if (item.HAS_ERROR==='Y') {
<span class="form-error-container">
                      {{item.ATTRIB_VALUE_ERROR}}
                    </span>
}
                  </p>
}
                  @if (item.EDIT_TYPE==='label' && item.DATA_TYPE==='string') {
<p>
                    {{item.ATTRIB_VALUE}}
                  </p>
}
                  </td>
}
                
}

                <!-- CH (Child/Detail) Row Type (matches f-4562 with horizontal scroll) -->
                @if (row.ROW_TYPE==='CH') {
<td colspan="12" class="ch-table-cell">
                  <div class="table-scroll-wrapper">
                  <table class="table table-bordered form-inline InnerTblBG custom-table">
                    @for (item of row.Line_data; track trackByIndex(parentIndex); let parentIndex = $index) {
<tr class="row">
                      <!-- HEADER_ROW -->
                      @if (item.Line_Type==='HEADER_ROW') {

                        @for (column of item.Line_data_occ.slice(0, item.Line_data_occ.length-1); track $index) {
<th class="row">
                        @if (column.ATTRIB_DESCRIPTION != 'Comments') {
<p>{{column.ATTRIB_VALUE}}</p>
}
                        </th>
}
                      
}

                      <!-- SUB_ROW (Add button row) -->
                      @if (item.Line_Type==='SUB_ROW') {
<td class="row">
                        {{item.Line_no}}
                        <i class="fa fa-plus-circle color-green fa-lg pull-right"
                           style="cursor: pointer; margin-top: 4px;"
                           title="Add Details"
                           (click)="addNewRow(item.Line_no)"></i>
                      </td>
}
                      @if (item.Line_Type==='SUB_ROW') {
<td colspan="11" class="row">
                        Add Details
                      </td>
}

                      <!-- DATA_ROW (Read-only display) -->
                      @if (item.Line_Type==='DATA_ROW' && item.Is_Multi==='Y') {
<td class="row">
                        @if (item.IS_EDITABLE==='Y') {
<i class="fa fa-pencil bluepencil pull-left"
                          
                           style="cursor: pointer; margin-top: 4px;"
                           title="Edit Details"
                           (click)="editExistingRecord(item.Line_no, item.Occurrence, parentIndex)"></i>
}
                        @if (item.IS_EDITABLE==='Y') {
<i class="fa fa-minus-circle color-red fa-lg pull-right"
                          
                           style="cursor: pointer; margin-top: 4px;"
                           title="Remove Details"
                           (click)="removeExistingRecord(item.Line_no, item.Occurrence, parentIndex)"></i>
}
                      </td>
}
                      @if (item.Line_Type==='DATA_ROW' && item.Is_Multi==='Y') {

                        @for (column of item.Line_data_occ.slice(1, item.Line_data_occ.length-1); track $index) {
<td class="row">
                        @if (column.ATTRIB_DESCRIPTION != 'Comments' && column.DATA_TYPE == 'number') {
<p 
                           [ngClass]="{'color-red': column.ATTRIB_VALUE < 0}">
                          {{column.ATTRIB_VALUE | numberWithCommas}}
                          @if (column.HAS_ERROR==='Y') {
<span class="form-error-container">
                            {{column.ATTRIB_VALUE_ERROR}}
                          </span>
}
                        </p>
}
                        @if (column.ATTRIB_DESCRIPTION != 'Comments' && column.DATA_TYPE != 'number' && column.ATTRIB_DESCRIPTION === 'Classification Type') {
<p>
                          {{classification[column.ATTRIB_VALUE]}}
                          @if (column.HAS_ERROR==='Y') {
<span class="form-error-container">
                            {{column.ATTRIB_VALUE_ERROR}}
                          </span>
}
                        </p>
}
                        @if (column.ATTRIB_DESCRIPTION != 'Comments' && column.DATA_TYPE != 'number' && column.ATTRIB_DESCRIPTION !== 'Classification Type') {
<p>
                          {{column.ATTRIB_VALUE}}
                          @if (column.HAS_ERROR==='Y') {
<span class="form-error-container">
                            {{column.ATTRIB_VALUE_ERROR}}
                          </span>
}
                          <!-- View/Edit button for Property Section (matches AngularJS) -->
                          @if (column.EDIT_TYPE==='select' && column.DATA_TYPE==='string' && column.ATTRIB_VALUE !== '1245' && column.ATTRIB_DESCRIPTION === 'Property Section') {
<button type="button" 
                                 
                                  style="border: none; padding: 0; background: none; color: Blue;"
                                  (click)="enterSectionDetails(column.ATTRIB_SHORT_CODE, mainIndex, parentIndex, column.ATTRIB_VALUE, column.OCCURRENCE)">(View/Edit)</button>
}
                        </p>
}
                        </td>
}
                      
}

                      <!-- DATA_COMMENTS (Read-only comments) -->
                      @if (item.Line_Type==='DATA_COMMENTS' && item.Is_Multi==='Y') {
<td 
                          style="text-align: left !important" 
                          colspan="2" class="row">
                        <h4 style="font-weight: bold;">{{item.Line_data_occ[0].ATTRIB_DESCRIPTION}}:</h4>
                      </td>
}
                      @if (item.Line_Type==='DATA_COMMENTS' && item.Is_Multi==='Y') {
<td colspan="10" class="row">
                        {{item.Line_data_occ[0].ATTRIB_VALUE}}
                      </td>
}

                      <!-- NEW_EDIT_ROW (Editable row) -->
                      @if (item.Line_Type==='NEW_EDIT_ROW' && item.Is_Multi==='Y') {
<td class="row">
                        <i class="fa fa-check-circle color-green fa-lg pull-left"
                           style="cursor: pointer; margin-top: 4px;"
                           title="Save Details"
                           (click)="saveNewEdittedRecord(item.Line_no, item.Occurrence, parentIndex)"></i>
                        <i class="fa fa-minus-circle color-red fa-lg pull-right"
                           style="cursor: pointer; margin-top: 4px;"
                           title="Remove Details"
                           (click)="removeExistingRecord(item.Line_no, item.Occurrence, parentIndex)"></i>
                      </td>
}
                      @if (item.Line_Type==='NEW_EDIT_ROW' && item.Is_Multi==='Y') {

                        @for (column of item.Line_data_occ.slice(1, item.Line_data_occ.length-1); track $index; let colIndex = $index) {
<td class="row">
                        @if (column.EDIT_TYPE==='label' && column.DATA_TYPE==='number') {
<p>
                          {{column.ATTRIB_VALUE}}
                          @if (column.HAS_ERROR==='Y') {
<span class="form-error-container" 
                               >
                            {{column.ATTRIB_VALUE_ERROR}}
                          </span>
}
                        </p>
}
                        
                        <!-- Radio buttons for Perm/Temp -->
                        @if (column.EDIT_TYPE==='radio' && column.DATA_TYPE==='string') {
<p>
                          <input class="radio-inline" 
                                 type="radio" 
                                 [(ngModel)]="column.ATTRIB_VALUE" 
                                 value="Perm" 
                                 (ngModelChange)="valueChanged(parentIndex, column.OCCURRENCE, column.LINE_NO, colIndex)"> Perm
                          <input class="radio-inline" 
                                 type="radio" 
                                 [(ngModel)]="column.ATTRIB_VALUE" 
                                 value="Temp" 
                                 (ngModelChange)="valueChanged(parentIndex, column.OCCURRENCE, column.LINE_NO, colIndex)"> Temp
                        </p>
}

                        <!-- Property Section dropdown -->
                        @if (column.EDIT_TYPE==='select' && column.DATA_TYPE==='string' && column.ATTRIB_DESCRIPTION === 'Property Section') {
<p>
                          <select [(ngModel)]="column.ATTRIB_VALUE" class="form-control"
                                    (ngModelChange)="valueChanged(parentIndex, column.OCCURRENCE, column.LINE_NO, colIndex)">
                            @for (sec of section; track $index) {
<option [value]="sec">{{sec}}</option>
}
                          </select>
                        </p>
}

                        <!-- Classification Type dropdown -->
                        @if (column.EDIT_TYPE === 'select' && column.DATA_TYPE === 'string' && column.ATTRIB_DESCRIPTION === 'Classification Type') {
<p>
                          <select [(ngModel)]="column.ATTRIB_VALUE" class="form-control"
                                  class="classification-dropdown form-control"
                                  (ngModelChange)="valueChanged(parentIndex, column.OCCURRENCE, column.LINE_NO, colIndex)">
                            @for (key of ['NA', 'Worthless', 'Other']; track $index) {
<option [value]="key">
                              {{classification[key]}}
                            </option>
}
                          </select>
                          @if (column.HAS_ERROR==='Y') {
<span class="form-error-container" 
                               >
                            {{column.ATTRIB_VALUE_ERROR}}
                          </span>
}
                        </p>
}

                        <!-- Text input (textarea for property description) -->
                        @if (column.EDIT_TYPE==='text' && column.DATA_TYPE==='string') {
<p>
                          <textarea style="width: 100%" 
                                    class="form-control input-sm numText"
                                    [(ngModel)]="column.ATTRIB_VALUE"
                                    placeholder="<-- Description -->"
                                    (ngModelChange)="valueChanged(parentIndex, column.OCCURRENCE, column.LINE_NO, colIndex)"></textarea>
                          @if (column.HAS_ERROR==='Y') {
<span class="form-error-container" 
                               >
                            {{column.ATTRIB_VALUE_ERROR}}
                          </span>
}
                        </p>
}

                        <!-- Currency input -->
                        @if (column.EDIT_TYPE==='currency' && column.DATA_TYPE==='number') {
<p>
                          <input [(ngModel)]="column.ATTRIB_VALUE" 
                                 class="form-control input-md numText" 
                                 type="text"
                                 onlyDigitsDecimal
                                 (blur)="updateAmount(parentIndex, column.LINE_NO)" 
                                 (ngModelChange)="valueChanged(parentIndex, column.OCCURRENCE, column.LINE_NO, colIndex)">
                          @if (column.HAS_ERROR==='Y') {
<span class="form-error-container" 
                               >
                            {{column.ATTRIB_VALUE_ERROR}}
                          </span>
}
                        </p>
}

                        <!-- Checkbox (matches f-4562 pattern) -->
                        @if (column.EDIT_TYPE==='checkbox' && column.DATA_TYPE==='string') {
<p>
                          <input type="checkbox" class="form-control"
                                 [checked]="column.ATTRIB_VALUE === 'Y'" 
                                 (change)="onCheckboxChangeColumn(column, parentIndex, column.OCCURRENCE, column.LINE_NO, colIndex, $event)">
                        </p>
}

                        <!-- Date picker with VARIOUS option (matches f-4562 pattern) -->
                        @if (column.EDIT_TYPE==='custom_date_various' && column.DATA_TYPE==='dateVarious') {
<div class="date-various-container">
                          <div class="form-inline" style="white-space: nowrap; min-width: 150px;">
                            <div class="form-group" style="margin: 0">
                              <input type="checkbox" 
                                     [checked]="column.ATTRIB_VALUE === 'VARIOUS'" 
                                     (change)="onDateVariousCheckboxChange(column, parentIndex, column.OCCURRENCE, column.LINE_NO, colIndex, $event)"
                                     title="Various"
                                     style="margin-right: 5px;">
                            </div>
                            <div class="form-group" style="margin: 0">
                              @if (column.ATTRIB_VALUE !== 'VARIOUS') {
<input 
                                     type="date" 
                                     class="form-control"
                                     [(ngModel)]="column.ATTRIB_VALUE" 
                                     (ngModelChange)="valueChanged(parentIndex, column.OCCURRENCE, column.LINE_NO, colIndex)"
                                     style="min-width: 150px;">
}
                              @if (column.ATTRIB_VALUE === 'VARIOUS') {
<input 
                                     type="text" 
                                     class="form-control" 
                                     value="VARIOUS" 
                                     disabled
                                     style="min-width: 150px;">
}
                            </div>
                          </div>
                          @if (column.HAS_ERROR==='Y') {
<span class="form-error-container" 
                               >
                            {{column.ATTRIB_VALUE_ERROR}}
                          </span>
}
                        </div>
}
                        </td>
}
                      
}

                      <!-- NEW_EDIT_COMMENT_ROW (Editable comments) -->
                      @if (item.Line_Type==='NEW_EDIT_COMMENT_ROW' && item.Is_Multi==='Y') {
<td 
                          style="text-align: left !important" 
                          colspan="2" class="row">
                        <h4 style="font-weight: bold;">{{item.Line_data_occ[0].ATTRIB_DESCRIPTION}}:</h4>
                      </td>
}
                      @if (item.Line_Type==='NEW_EDIT_COMMENT_ROW' && item.Is_Multi==='Y') {
<td colspan="10" class="row">
                        <textarea style="width: 100%" 
                                  class="form-control input-sm"
                                  [(ngModel)]="item.Line_data_occ[0].ATTRIB_VALUE"
                                  placeholder="<--- Enter Comments here --->"
                                  (ngModelChange)="valueChanged(parentIndex, item.Line_data_occ[0].OCCURRENCE, item.Line_data_occ[0].LINE_NO, parentIndex)"></textarea>
                      </td>
}
                    </tr>
}
                  </table>
                  </div>
                </td>
}
              </tr>
}
            </table>
          </div>
        </div>
}
      </div>
    </div>
}
  </div>
</div>

<!-- STANDARD Footer -->
<div class="modal-footer" [hidden]="minimise">
  @if (currentTabName != 'Subsidiary') {
<button
          class="save-button"
          type="button"
          [disabled]="isSaveClicked || !isValidScenario || isLocked"
          (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save and Proceed
  </button>
}
  @if (currentTabName != 'Subsidiary') {
<button
          class="reset-button"
          type="button"
          [disabled]="isLocked"
          (click)="reset()">Reset</button>
}
  <button class="cancel-button" 
          type="button" 
          (click)="cancel()">Cancel</button>
</div>

